import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Button, EditContainer, Flex, MainHeadline, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { InventoryTransferModal } from './InventoryTransferModal'
import { clearInventoryTransfers, getInventoryTransfers } from 'features/inventory/inventoryTransfersSlice'
import { ViewInventoryTransferModal } from './ViewInventoryTransferModal'
import { IGetAllInventoryTransfersSingleResponse } from 'types/api/inventoryReceiptsApi.interface'
import { ArrowLeft } from 'assets/icons/ArrowLeft'

export const InventoryTransfers = () => {
    const { transfers, totalPages } = useSelector((store: RootState) => store.inventoryTransfers)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState(false)
    const [viewModal, setViewModal] = useState<{ open: boolean, value: IGetAllInventoryTransfersSingleResponse }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getInventoryTransfers], cleanUpFunctions: [clearInventoryTransfers], params })

    const columns: IHonestTableColumn<any>[] = [
        { id: 'date', header: 'DATE', cell: (item) => formatDateForDisplay(item.date, true) },
        { id: 'assignedEmployee', header: 'ASSIGNED EMPLOYEE', cell: (item) => item.assignedForUser ? (item.assignedForUser?.firstName + ' ' + item.assignedForUser?.lastName) : '/' },
        { id: 'fromLocation', header: 'FROM LOCATION', cell: (item) => item.fromLocation ? item.fromLocation.name : '/' },
        { id: 'toLocation', header: 'TO LOCATION', cell: (item) => item.toLocation ? item.toLocation.name : '/' },
        { id: 'items', header: 'ITEMS', cell: (item) => item.lines.length || '/' },
        { id: 'notes', header: 'NOTES', cell: (item) => item.notes || '/' },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <EditContainer onClick={() => setViewModal({ open: true, value: item })} >
                        <Flex style={{ transform: 'rotate(180deg)' }} className='arrow-table' >
                            <ArrowLeft />
                        </Flex>
                    </EditContainer>
                </span>
            ),
        },
    ]

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Transfers</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => setModal(true)} >
                        Add Transfer
                    </Button>
                </Flex>

            </Flex>
            {!transfers.length ? (
                <NoItems title='Transfers' />
            ) : (
                <HonestTable
                    columns={columns}
                    data={transfers}
                    keyField='id'
                    onClick={(item) => setViewModal({ open: true, value: item })}
                />
            )}
            {modal && <InventoryTransferModal closeModal={() => setModal(false)} />}
            {viewModal.open && <ViewInventoryTransferModal value={viewModal.value} closeModal={() => setViewModal({ value: null, open: false })} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}